import api from '../api';

const path = '/upload/image';

const uploadFileRequest = (formData) => {
    return api.post(path, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const deleteImageRequest = ({ imageName }) => {
    return api.delete(`${path}/${imageName}`);
};

const deleteImagesRequest = (images) => {
    return api.delete(`/upload/images`, {
        data: { images },
    });
};

const getImagesRequest = (advertId) => {
    return api.get('/upload/images/get', {
        params: { advertId },
    });
};

export {
    deleteImageRequest,
    deleteImagesRequest,
    uploadFileRequest,
    getImagesRequest,
};
